// File: /js/pages/subscribe.js

import { show, hide } from '/js/shared/utils/DOMUtils.js';

/** Live-checks password_1 against each rule within a given container */
function checkPasswordRules(value, container = document) {
  const checks = [
    { rule: 'minLength',   test: v => v.length >= 8 },
    { rule: 'uppercase',   test: v => /[A-Z]/.test(v) },
    { rule: 'lowercase',   test: v => /[a-z]/.test(v) },
    { rule: 'number',      test: v => /\d/.test(v) },
    { rule: 'specialChar', test: v => /[!@#$%^&*_]/.test(v) },
  ];

  const scope = container.querySelector('.password-rules') || container;

  checks.forEach(({ rule, test }) => {
    const tick = scope.querySelector(`[data-rule="${rule}"]`);
    if (!tick) return;
    test(value) ? show(tick) : hide(tick);
  });
}

/** Attach validators to a single form */
function wirePasswordValidation(form) {
  const pw1      = form.querySelector('input[name="password_1"]');
  const pw2      = form.querySelector('input[name="password_2"]');
  const errorDiv = form.querySelector('#pw2-error');

  if (!pw1 || !pw2 || !errorDiv) return;

  pw1.addEventListener('input', e => {
    checkPasswordRules(e.target.value, form);
    pw2.value = '';
    hide(errorDiv);
  });

  pw2.addEventListener('blur', () => {
    if (pw2.value && pw2.value !== pw1.value) {
      show(errorDiv);
      pw2.value = '';
    } else {
      hide(errorDiv);
    }
  });

  pw2.addEventListener('focus', () => {
    if (!pw2.value) hide(errorDiv);
  });

  pw2.addEventListener('input', () => hide(errorDiv));

  form.addEventListener('submit', e => {
    if (pw2.value !== pw1.value) {
      show(errorDiv);
      e.preventDefault();
    }
  });
}

/** Initialize on subscribe, changePassword AND resetPassword forms */
export function initSubscribeValidation() {
  const forms = document.querySelectorAll(
    'form[data-name="subscribe"], form[data-name="changePassword"], form[data-name="resetPassword"]'
  );
  forms.forEach(wirePasswordValidation);
}

document.addEventListener('DOMContentLoaded', initSubscribeValidation);
